import React from 'react'
import { EmailConfirmIcon, CheckConfirmationIcon, ExpiredConfirmationIcon, AlertDisabledThinIcon } from 'images/common';
import { VuiIcon } from '@topkamera/viso-ui';

export const ICON = {
  MAIL: 'mail',
  CHECK: 'check',
  EXPIRED: 'expired',
  LOCKED: 'locked',
  UNSUBSCRIBED: 'unsubscribed'
}

const ICON_COMPONENT = {
  [ICON.MAIL]: <EmailConfirmIcon />,
  [ICON.CHECK]: <CheckConfirmationIcon />,
  [ICON.EXPIRED]: <ExpiredConfirmationIcon />,
  [ICON.UNSUBSCRIBED]: <AlertDisabledThinIcon />,
  [ICON.LOCKED]: <VuiIcon name='lockThin' size='lg' />
}

const ConfirmationElement = ({ icon = ICON.MAIL, color = 'success' }) => {
  return (
    <div className={`confirmation-element confirmation-element--${color}`}>
      {ICON_COMPONENT[icon]}
    </div>
  )
}

export default ConfirmationElement